// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__TY-1c","item":"PaymentsMobile_item__2I1w4","label":"PaymentsMobile_label__winX1","amount":"PaymentsMobile_amount__1lbdx"};